/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import {
	setFilteredInvoices,
	setInvoiceSearch,
	filterInvoices,
	setPanelKey,
	setSalesMenSearch,
} from 'store/invoiceSlice';
import { Box } from 'atoms';
import { SearchBox } from './Collection.style';

const Container = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 15px 10px;
	background-color: white;
`;

const Search = styled.input`
	height: 40px;
	padding: 10px;
	border: 0;
	border-radius: 4px 0px 0px 4px;
	background-color: ${(props) => props.theme.colors.Cultured};
	color: ${(props) => props.theme.colors.primary};
	&:focus {
		outline: none;
	}

	::placeholder,
	::-ms-input-placeholder {
		/* Chrome, Firefox, Opera, Safari 10.1+ */
		color: ${(props) => props.theme.colors.primary};
		opacity: 1; /* Firefox */
	}
`;

const Go = styled.div`
	height: 40px;
	width: 53px;
	background-color: ${(props) => props.theme.colors.DodgerBlue};
	border-radius: 0px 4px 4px 0px;
	line-height: 40px;
	text-align: center;
	color: white;
	cursor: pointer;
`;

const InvoiceCountContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 32px;
	width: 37px;
	margin: auto 0.4rem;
	border: 1px solid #007fff;
	border-radius: 4px;
`;

const SearchError = styled.p`
	font-size: 12px;
	color: red;
	position: absolute;
	top: 41px;
	left: 0;
	width: 100%;
	text-align: center;
`;

// function findMatches(invoices, salesMenSearch) {
// 	return invoices.some(
// 		(invoice) =>
// 			invoice.invoice_no.toLowerCase().includes(salesMenSearch.toLowerCase()) ||
// 			invoice.store_name.includes(salesMenSearch)
// 	);
// }

let panelArray = [];

export default function InvoiceSearch() {
	const [search, setSearch] = useState('');
	const [totalInvoices, setTotalInvoices] = useState();
	const [pendingInvoices, setPendingInvoices] = useState();
	const { invoices = [], salesMenSearch = '' } = useSelector((state) => state.invoice);
	const dispatch = useDispatch();

	console.log(salesMenSearch);

	useEffect(() => {
		const myCollection = invoices?.filter((item) => item?.status === 'Pending');
		const total = invoices.length;
		const pending = myCollection.length;

		setTotalInvoices(total);
		setPendingInvoices(total - pending);
	}, [invoices]);

	// useEffect(() => {

	// 		setSearch(salesMenSearch);
	// 	} else {
	// 		setSearch('');
	// 	}
	// }, [salesMenSearch, invoices]);

	const handleFindInvoices = useCallback(() => {
		panelArray = [];
		if (invoices?.length > 0 && search !== '') {
			/**
			 * Find searched word in invoice store namd and invoice id
			 */
			const filteredData = filterInvoices(invoices, search);

			dispatch(setFilteredInvoices(filteredData)); // updated invoices as filtered invoices
			filteredData.length > 0 && panelArray.push('1');
		}

		dispatch(setPanelKey(panelArray));

		dispatch(setInvoiceSearch(search)); // store searched word in redux
	}, [invoices, search, dispatch]);

	useEffect(() => {
		if (search !== '') {
			handleFindInvoices();
		}
	}, [search, handleFindInvoices]);

	function resetFilter() {
		/**
		 * if search input is empty clear filtered invoice with all invoice
		 */
		dispatch(setFilteredInvoices(invoices));
		dispatch(setSalesMenSearch(''));
		dispatch(setPanelKey(['1']));
	}

	return (
		<Container>
			<InvoiceCountContainer>
				<Box as="div" fontSize="12px" fontWeight="300" p="5px">
					{pendingInvoices}/{totalInvoices}
				</Box>
			</InvoiceCountContainer>
			<SearchBox>
				<Search
					placeholder="Search Invoice/Store..."
					value={search}
					onChange={(e) => {
						setSearch(e.target.value);
						if (e.target.value === '') {
							/**
							 * Bring back full invoices without filter
							 */
							resetFilter();
							dispatch(setInvoiceSearch(' '));
						}
					}}
				/>

				{search !== '' && panelArray.length === 0 && (
					<SearchError>No Invoice found</SearchError>
				)}
			</SearchBox>

			<Go onClick={handleFindInvoices}>Go</Go>
		</Container>
	);
}
